import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines = [], delay = 0, inView = true }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-60px" });
  const show = !inView || seen;
  return (
    <span className="block" ref={ref}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: show ? 0 : "115%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, lines, className = "", testId }) => (
  <div className={className} data-testid={testId}>
    <FadeUp>
      <p className="font-mono text-xs font-medium uppercase tracking-[0.25em] text-brand">{overline}</p>
    </FadeUp>
    <h2 className="mt-5 font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-paper sm:text-4xl lg:text-5xl">
      <MaskedLines lines={lines} delay={0.05} />
    </h2>
  </div>
);

export const Counter = ({ to, suffix = "", decimals = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: EASE,
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {val.toFixed(decimals)}
      {suffix}
    </span>
  );
};
